import App from './App.svelte';

(async () => {
    console.log("MusicKit loaded");
    await MusicKit.configure({
        app: {
            name: "musickit-experiment",
            version: "0.0.2",
        },
        developerToken: "DEVELOPER_TOKEN",
        declarativeMarkup: false,
    });
    console.log("MusicKit configured");

    const app = new App({
    	target: document.body
    });
})();

export default app;
